import getBaseUrl from '@uikit/helpers/getBaseUrl';
import { Fragment } from 'react';
import { LinkItem } from './types';

const baseUrl = getBaseUrl();

export const createAbsoluteJSXLink = (link: LinkItem) => (
  <a href={`${baseUrl}${link.path}`}>{link.name}</a>
);

export const createGermanAbsoluteLinks = (links: LinkItem[]) => {
  return links.map((link, index) => {
    const isLastIndex = index === links.length - 1;
    const isSecondLast = index === links.length - 2;
    const hasMultipleItems = links.length > 2;

    return (
      <Fragment key={link.name}>
        <a href={`${baseUrl}${link.path}`}>{link.name}</a>
        {isSecondLast && hasMultipleItems ? ' und ' : isLastIndex ? '' : ', '}
      </Fragment>
    );
  });
};
